const isSubset = (array1, array2) =>
  array2?.every(element => array1?.includes(element))

const filterPosts = (
  posts,
  relatedFocusAreas,
  relatedProjects,
  relatedResources,
  tagToShow,
  limit,
  skip
) => {
  // Skip the post with the same ID
  let filteredPosts = skip ? posts?.filter(post => post.id !== skip) : posts;

  if( relatedFocusAreas?.length === 0 && relatedProjects?.length === 0 && relatedResources?.length === 0 && tagToShow?.length === 0) {
    return limit ? filteredPosts.slice(0, limit) : filteredPosts;
  }

  // Filter by: relatedFocusAreas
  const focusAreasArray = relatedFocusAreas?.map(focusArea => focusArea.title)

  const focusAreaPosts = relatedFocusAreas?.length > 0
    && filteredPosts?.filter(post => {
        const postFocusAreas = post.relatedFocusAreas?.map(
          focusArea => focusArea.title
        )
        return isSubset(postFocusAreas, focusAreasArray)
      })
    

  // Filter by: relatedProjects
  const projectsArray = relatedProjects?.map(project => project.title)

  const projectsPosts = relatedProjects?.length > 0
    && filteredPosts?.filter(post => {
        const postProjects = post.relatedProjects?.map(project => project.title)
        return isSubset(postProjects, projectsArray)
      })

  // Filter by: relatedResources
  const resourcesArray = relatedResources?.map(resource => resource.title)

  const resourcesPosts = relatedResources?.length > 0
    && filteredPosts?.filter(post => {
        const postResources = post.relatedResources?.map(
          resource => resource.title
        )
        return isSubset(postResources, resourcesArray)
      })

  // Filter by: TagToShow
  const tagsArray = tagToShow && tagToShow.split(", ")

  const tagsPosts = tagToShow?.length > 0
    && filteredPosts?.filter(post => {
        const postThematicTags = post.thematicTags?.split(", ")
        const postStructuralTags = post.structuralTags?.split(", ")
        const allTags = postThematicTags?.concat(postStructuralTags)

        return isSubset(allTags, tagsArray)
      })

  filteredPosts = [focusAreaPosts, projectsPosts, resourcesPosts, tagsPosts].flat().filter(item => item !== undefined);
  // Show just n posts
  filteredPosts = limit ? filteredPosts?.slice(0, limit) : filteredPosts
  // Remove repeated and empty values
  filteredPosts = [...new Set(filteredPosts)].filter(n => n)

  return filteredPosts
}

export { filterPosts }
